import React from "react";
import { TOMOS, TOMO_FEATURES } from "../../data/content";
import { CheckIcon } from "lucide-react";
export function Tomos() {
  return <section className="bg-black py-16 px-4" data-id="element-236" data-mp="34rvz2hqdh7c">
      <div className="max-w-6xl mx-auto" data-id="element-237" data-mp="7xcntyh2tk88">
        <div className="text-center" data-id="element-238" data-mp="7ydy40q9q2ow">
          <span className="inline-block bg-[#e10600] text-white font-condensed tracking-widest text-lg px-4 py-1 rounded mb-4" data-id="element-239" data-mp="7zfd2gaen9bw">
            🏆 MEGAPACK 72HS™ — TU NEGOCIO DE COMIDAS LISTO
          </span>
          <h2 className="font-display text-4xl sm:text-6xl text-white uppercase leading-none" data-id="element-240" data-mp="3gcwd6memmii0">
            6 Tomos <span className="text-[#e10600]" data-id="element-241" data-mp="3lbz8hf4t1acs">+</span> 6 Bonos
          </h2>
          <p className="font-condensed text-2xl text-neutral-300 mt-2 tracking-wide" data-id="element-242" data-mp="3le272nk0wbt4">
            450+ páginas — Todo resuelto.
          </p>
          <p className="text-neutral-400 mt-3" data-id="element-243" data-mp="10m9vz8rkq0n9">
            🍕 Pizza · 🎂 Pastelería · 🍝 Pasta · 🌾 Sin TACC · 👻 Ghost Kitchen · 💰 Finanzas
          </p>
        </div>

        <h3 className="font-condensed text-3xl text-[#e10600] tracking-wide text-center mt-12 mb-6" data-id="element-244" data-mp="15mo56u4wvgmv">
          6 Tomos Completos
        </h3>

        <div className="grid gap-5 md:grid-cols-2" data-id="element-245" data-mp="1cuqq21kwb135">
          {TOMOS.map(t => <article key={t.n} className="group bg-neutral-950 border border-neutral-800 rounded-2xl p-6 hover:border-[#e10600] transition-colors" data-id="element-246" data-mp="18ru1zvcl6crt">
              <div className="flex items-center gap-3 mb-3" data-id="element-247" data-mp="13shgbdxgbbqt">
                <span className="text-4xl" data-id="element-248" data-mp="yufz6yjl5mhz">{t.emoji}</span>
                <div data-id="element-249" data-mp="yvzg8rd2g1kt">
                  <div className="font-display text-[#e10600] text-sm tracking-wide" data-id="element-250" data-mp="u366tq6nk52e">{t.n}</div>
                  <h4 className="font-display text-xl sm:text-2xl text-white uppercase leading-none" data-id="element-251" data-mp="p434idi24cy4">
                    {t.title}
                  </h4>
                </div>
              </div>
              <p className="font-condensed text-lg text-neutral-300 tracking-wide" data-id="element-252" data-mp="g3f0mbmdnsyy">{t.subtitle}</p>
              <p className="text-neutral-400 text-sm mt-2 leading-relaxed" data-id="element-253" data-mp="b4busoykpipx">{t.desc}</p>
            </article>)}
        </div>

        <div className="mt-12 bg-neutral-950 border border-neutral-800 rounded-2xl p-6 sm:p-8 max-w-4xl mx-auto" data-id="element-254" data-mp="1g6isrykcpe0">
          <h3 className="font-condensed text-2xl text-white tracking-wide mb-5 text-center" data-id="element-255" data-mp="6gu9fcivr47p">
            Cada tomo incluye:
          </h3>
          <ul className="grid gap-3 sm:grid-cols-2" data-id="element-256" data-mp="3nq0rfhpccpmg">
            {TOMO_FEATURES.map((f, i) => <li key={i} className="flex items-start gap-2.5 text-neutral-300 text-sm" data-id="element-257" data-mp="3snj1jbf3haw1" data-mpi={i}>
                <CheckIcon className="w-5 h-5 text-[#e10600] flex-shrink-0 mt-0.5" data-id="element-258" data-mp="k8iif6xu1ckg" />
                {f}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}